module.exports = __webpack_public_path__ + "img/shiLin1.00ec17cd.png";